export function checkMaster(file) {
  return file["extension"] === "oc5m" || file["extension"] === "ocb";
}
